import { ApplicationConfig } from '@angular/core';
import {
  provideRouter,
  TitleStrategy,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig
} from '@angular/router';
import { CoreRoutes } from '@zaoblako/web/core/core.router';
import { ErrorHandler, InjectionToken, LOCALE_ID } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from '@zaoblako/web/core/interceptors/error.interceptor';
import { TokenInterceptor } from '@zaoblako/web/core/interceptors/token.interceptor';
import { CacheInterceptor } from '@zaoblako/web/core/interceptors/cache.interceptor';
import { GlobalErrorHandler } from '@zaoblako/web/core/services/error-handler.service';
import { CustomTitleStrategy } from '@zaoblako/web/core/strategy/custom.title.strategy';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DecimalPipe } from '@angular/common';
import { FormStoreService } from '@zaoblako/web/shared/components/form-sidebar/services/form-store.service';

export const INTL_RTF = new InjectionToken<Intl.RelativeTimeFormat>('');

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      CoreRoutes,
      withEnabledBlockingInitialNavigation(),
      withRouterConfig({ onSameUrlNavigation: 'ignore' }),
      withInMemoryScrolling({ scrollPositionRestoration: 'disabled' })
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    { provide: LOCALE_ID, useValue: 'ru-RU' },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
    {
      provide: INTL_RTF,
      useFactory: () => new Intl.RelativeTimeFormat('ru')
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    MessageService,
    ConfirmationService,
    DecimalPipe,
    FormStoreService
  ]
};
